<template lang="pug">
  .app-content.container
    h3 กรุณากรอกใบสมัครงานออนไลน์ของคุณ
    header.step-header
      ul.steps.d-flex.justify-content-between
        li.step-item(
          @click="$store.commit('SET_STEP', 1)"
          :class="{ 'is-active' : step === 1 }"
        )
          a
            icon-account
            strong ประวัติส่วนตัว
            span Personal Data
          icon-arrow-next.step-separator

        li.step-item(
          @click="$store.commit('SET_STEP', 2)"
          :class="{ 'is-active' : step === 2 }"
        )
          a
            icon-cap
            strong ประวัติการศึกษา
            span Education
          icon-arrow-next.step-separator

        li.step-item(
          @click="$store.commit('SET_STEP', 3)"
          :class="{ 'is-active' : step === 3 }"
        )
          a
            icon-cap
            strong  ทักษะทางภาษาและทักษะพิเศษ
            span Knowledge Of Languages <br> and Special Abilities
          icon-arrow-next.step-separator

        li.step-item(
          @click="$store.commit('SET_STEP', 4)"
          :class="{ 'is-active' : step === 4 }"
        )
          a
            icon-card
            strong ประวัติการทำงาน
            span Employment Record
          icon-arrow-next.step-separator

        li.step-item(
          :class="{ 'is-active' : step === 5 }"
        )
          a
            icon-confirm
            strong ยืนยันข้อมูลการสมัคร
            span Confirm Information

    .step-content
      step-1(v-if="step === 1" :step="step")
      step-2(v-if="step === 2")
      step-3(v-if="step === 3")
      step-4(v-if="step === 4")
      step-5(v-if="step === 5")

    //- footer.form-footer
    //-   .d-flex.justify-content-center
    //-     button.back(v-if="step > 1 && step !== 5" @click="prevStep") กลับสู่ก่อนหน้า
    //-     button.next(v-if="step !== 5" @click="step = step") บันทึกและไปขั้นต่อไป
    //-     button.finish(v-else) ยืนยันการสมัครงาน
</template>

<script>
import { mapState } from 'vuex'
import MoveTo from 'moveTo'
import IconAccount from '../../icons/Account.vue'
import IconCap from '../../icons/Cap.vue'
import IconLanguage from '../../icons/Language.vue'
import IconCard from '../../icons/Card.vue'
import IconConfirm from '../../icons/Success.vue'
import IconArrowNext from '../../icons/ArrowNext2.vue'
import Step1 from '../components/Step1.vue'
import Step2 from '../components/Step2.vue'
import Step3 from '../components/Step3.vue'
import Step4 from '../components/Step4.vue'
import Step5 from '../components/Step5.vue'

export default {
  watch: {
    step: function (val) {
      setTimeout(() => {
      const moveTo = new MoveTo()
        moveTo.move(document.querySelector('.step-header'), {
          tolerance: 132,
          duration: 800,
        })
      }, 200);
    },
  },
  components: { IconAccount, IconCap, IconLanguage, IconCard, IconConfirm, IconArrowNext, Step2, Step3, Step4, Step1, Step5 },

  computed: {
    ...mapState(['step'])
  },

  // data: () => ({
  //   step: 1
  // }),

  methods: {
    nextStep() {
      this.submit = this.step
      // this.$store.commit('SET_STEP', this.step + 1)
    },
    prevStep() {
      this.$store.commit('SET_STEP', this.step - 1)
    },
  }
}
</script>

<style lang="scss">
.form {
  &-footer {
    margin: 4rem 0 0;
    padding-top: 3rem;
    padding-bottom: 4rem;
    border-top: solid 1px #cfd1d2;

    button {
      color: #19499C;
      font-size: 1.375rem;
      border: solid 1px #19499C;
      padding: 0.5rem 2.5rem;
      margin: 0 1rem;
      outline: none;
      background: transparent;

      &.next:hover {
        color: #fff;
        background: #19499c;
      }

      &.back {
        color: #6d6e71;
        background: #f1f2f2;
        border-color: #bcbec0;
      }

      &.finish {
        color: #fff;
        background: #19499C;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.step {
  &-header {
    margin-bottom: 5rem;
  }

  &-content {
    img {
      width: 100%;
    }

    ::v-deep {
      .form {
        label {
          font-weight: 600;
          white-space: nowrap;
          font-size: 20px;
          color: #58595b;
        }

        .pl-75 {
          padding-left: 66px;
        }

        .mr-2rem{
          // margin-right: -2rem;
          margin-right: -35%;
          padding-right: 35%;
        }

        .ml-9px {
          margin-left: -9px;
        }

        .custom-control-inline {
          margin-right: 2.5rem;

          &:last-child {
            margin-right: 0;
          }
        }

        &-group {
          margin-bottom: 0;
        }

        &-title {
          font-size: 28px;
          color: #414042;
          margin-bottom: 3rem;

          small {
            font-weight: 500;
          }
        }

        &-subtitle {
          position: relative;
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 2rem;
        }

        &-item {
          padding: 2rem 4rem;

          &.has-bg {
            padding-top: 2rem;
            background: #f5fbfe;
          }
        }
      }
    }
  }
}

h3 {
  padding-top: 4rem;
  text-align: center;
  color: #1a4a99;
  font-size: 2rem;
  margin-bottom: 3rem;
}

header {
  border: solid 1px #cfd1d2;
  padding: 1.25rem 2rem;
}

.step {

  &s {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &-item {
    position: relative;

    a {
      color: #808285;
      line-height: 1;
      text-align: center;
      font-size: 20px;
    }

    &.is-active {
      a {
        color: #1a4a99;
      }

      ::v-deep {
        .cls-1 {
          fill:#1a4a99;
        }
      }
    }

    span {
      font-size: 1.125rem;
      display: block;
    }

    svg {
      width: 50px;
      height: 50px;
      display: block;
      margin: 0 auto 1rem;
    }


    &__education {
      svg {
        width: 56px;
      }
    }

    &__confirm,
    &__skills {
      svg {
        width: 44px;
      }
    }

    ::v-deep {
      .cls-1 {
        fill:#808285;
      }
    }
  }

  &-separator {
    position: absolute;
    right: -3.25rem;
    top: 4rem;
    width: 10px !important;
    height: 20px !important;

    ::v-deep {
      .step-item.is-active & {
        .cls-1 {
          stroke: #1a4a99;
        }
      }
    }
  }
}
</style>
